import type { PlanHuntStand } from './types'

/**
 * Assign `hunterId` to `standId` within a drive, enforcing one stand per hunter
 * per drive (CLUB-158). If the hunter already occupies ANOTHER stand in this
 * drive they are MOVED here — their previous stand is vacated — matching the
 * mobile app (`plan_drive_bloc._onUpdateStandHunterEvent`). Pass `hunterId` =
 * null to unassign the target stand.
 *
 * `stands` is a single drive's stands, so the rule is naturally scoped per-drive
 * — the same hunter can still be placed in a different drive.
 */
export function moveHunterToStand(
  stands: PlanHuntStand[],
  standId: string,
  hunterId: string | null,
): PlanHuntStand[] {
  return stands.map((s) => {
    if (s.id === standId) return { ...s, assignedId: hunterId }
    // Pull the hunter off any other stand they occupied in this drive.
    if (hunterId !== null && s.assignedId === hunterId) return { ...s, assignedId: null }
    return s
  })
}
